import { Component, Prop, h, State, Event, EventEmitter, Element } from '@stencil/core';

@Component({
    tag: 'web-chatbot-small',
    styleUrls: ['chatbot-small.scss'],
    shadow: false
})
export class ChatbotSmall {
    @Element() hostElement: HTMLWebChatbotSmallElement;

    @Prop() expanded = false;

    @Prop() placeholderText = '';
    @Prop() submitButtonText = '';
    @Prop() maxLengthText = '';
    @Prop() maxlength = 150;
    @Prop() startupText = '';
    @Prop() closeOnSubmit = true;

    @State() isExpanded: boolean;

    @Event() valueChanged: EventEmitter<string>;

    connectedCallback() {
        this.isExpanded = this.expanded;
    }

    private emitValue = async (event: CustomEvent<string>) => {
        this.valueChanged.emit(event.detail);

        if (this.closeOnSubmit) {
            this.hostElement
                .querySelector('web-accordion .accordion > button')
                ?.dispatchEvent(new PointerEvent('click'));
        }
    };

    private onToggle = ({ detail }) => {
        if (detail?.toggle) {
            this.hostElement.querySelector<HTMLInputElement>('web-chatbot-input input[type="text"]')?.focus();
        }
    };

    render = () => {
        return (
            <div class="web-balloon left-top secondary padding-large">
                <web-accordion
                    label={this.startupText}
                    icon-closed="chevron-down"
                    icon-opened="chevron-up"
                    onAccordionToggle={this.onToggle}
                >
                    <web-chatbot-input
                        maxlength={this.maxlength}
                        maxLengthText={this.maxLengthText}
                        submitButtonText={this.submitButtonText}
                        submitButtonEnabled={true}
                        placeholderText={this.placeholderText}
                        onValueEmitted={this.emitValue}
                    ></web-chatbot-input>
                </web-accordion>
            </div>
        );
    };
}
